import React from "react";
import { node } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";

const EndososEcheck = ({ data }) => (
    <GridTable.Container columns={3} columnsTemplate="fixed">
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.cession.cessionId"
                        titleTextType="I18N"
                        valueText={data?.cesion_id ? data?.cesion_id : "N/A"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.cession.state"
                    titleTextType="I18N"
                    valueText={data?.estado_cesion ? data?.estado_cesion : "N/A"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.cession.issuerDni"
                    titleTextType="I18N"
                    valueText={data?.cedente_documento ? data?.cedente_documento : "N/A"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.cession.beneficiary"
                    titleTextType="I18N"
                    valueText={data?.cedente_nombre ? data?.cedente_nombre : "N/A"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.cession.beneficiaryDni"
                    titleTextType="I18N"
                    valueText={
                        data?.cesionario_documento
                            ? `${data?.cesionario_documento} ${data?.cesionario_documento_tipo}`
                            : "NA"
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.cession.beneficiaryAddress"
                    titleTextType="I18N"
                    valueText={data?.cesionario_domicilio ? data?.cesionario_domicilio : "NA"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.cession.registry"
                    titleTextType="I18N"
                    valueText={data?.entidadRegistro ? data?.entidadRegistro : "N/A"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.cession.dateTime"
                    titleTextType="I18N"
                    valueText={<FormattedDate date={data?.fecha_emision_cesion} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.cession.modificationDateTime"
                    titleTextType="I18N"
                    valueText={
                        <FormattedDate date={data?.fecha_ult_modificacion_cesion} dateFormat="DD/MM/YYYY HH:mm:ss" />
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
    </GridTable.Container>
);

EndososEcheck.propTypes = {
    data: node.isRequired,
};

export default EndososEcheck;
